import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M12 1.875c5.592 0 10.125 4.533 10.125 10.125S17.592 22.125 12 22.125 1.875 17.592 1.875 12 6.408 1.875 12 1.875zm0 1.5a8.625 8.625 0 1 0 0 17.25 8.625 8.625 0 0 0 0-17.25zM12 15a1.063 1.063 0 1 1 0 2.125A1.063 1.063 0 0 1 12 15zm0-9.375a.75.75 0 0 1 .75.75v6.875a.75.75 0 1 1-1.5 0V6.375a.75.75 0 0 1 .75-.75z' />
  </svg>
);
